import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledFlex } from '../../../styles/common';
import { isNotPositiveNumber, validateAmount } from '../../../helpers/utils/amount-utils';
import { StyledText } from '../../../styles/text';
var AmountDisplay = function (_a) {
    var amount = _a.amount;
    var isAmountNegative = useMemo(function () { return isNotPositiveNumber(amount); }, [amount]);
    var validatedAmount = useMemo(function () { return validateAmount(amount); }, [amount]);
    var isMobile = useDeviceWidth();
    return (_jsx(StyledFlex, { justifyContent: "flex-end", alignItems: "center", children: _jsx(StyledText, { weight: "bold", whiteSpace: "nowrap", size: isMobile ? 'regular' : 'root', color: isAmountNegative ? 'black' : undefined, children: "".concat(validatedAmount) }) }));
};
export default AmountDisplay;
//# sourceMappingURL=index.js.map